import { Tooltip } from '@mui/material'
import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  border: 1px solid #e0e0e0;
  background-color: #FFFDE7;
  padding: .4rem;
  border-radius: 0.2rem;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;
`
export const Row = styled.div`
  display: flex;
`

export const Column = styled.div<{width?: string, center?: boolean}>`
  display: flex;
  flex-direction: column;
  justify-content: start;
  min-width: ${({ width }) => width || '100%'};
  align-items: ${({ center }) => (center ? 'center' : 'start')};
`

export const CounterTooltip = styled(Tooltip)``
